<template>
  <div v-if="analysisTitleData.length">
    <div
      v-for="item in analysisTitleData"
      :key="item.title"
      class="analysis-card"
      :class="{ 'is-mobile': isMobile }"
    >
      <div class="card-title" @click="item.visible = !item.visible">
        <i v-if="item.visible" class="icon-arrow-down-s-line t-iconfont"></i>
        <i v-else class="icon-arrow-up-s-line t-iconfont"></i>
        <span class="text">{{ item.title }}</span>
      </div>
      <template v-if="item.visible">
        <PerformanceAnalysis
          v-if="item.type === 'performanceAnalysis' && Object.keys(performanceAnalysisData).length"
          :analysis-info="performanceAnalysisData"
          :has-enable-rule="hasEnableRule"
          :status="status"
        ></PerformanceAnalysis>
        <ObjectionHandle
          v-if="item.type === 'objectionHandle' && Object.keys(objectionHandleData).length"
          :analysis-info="objectionHandleData"
          :status="status"
          @preview="handlePreview"
        ></ObjectionHandle>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import PerformanceAnalysis from './components/performance-analysis.vue'
import ObjectionHandle from './components/objection-handle.vue'

defineOptions({
  name: 'EmployeePerformance'
})

const props = defineProps({
  dataInfo: {
    type: Object,
    default: () => {}
  },
  status: {
    type: [String, Number],
    default: ''
  },
  isMobile: {
    type: Boolean,
    default: false
  },
  hasEnableRule: {
    type: Number,
    default: 1
  }
})

const emit = defineEmits(['preview'])
const analysisTitleData = ref([
  {
    visible: true,
    title: '员工表现分析',
    type: 'performanceAnalysis'
  },
  {
    visible: true,
    title: '员工能力分析',
    type: 'objectionHandle'
  }
])

const performanceAnalysisData = computed(() => {
  return props.dataInfo
    ? {
        aiASuggestion: props.dataInfo?.aiASuggestion,
        behavior: props.dataInfo?.behavior
      }
    : {}
})

const objectionHandleData = computed(() => {
  return props.dataInfo
    ? {
        content: props.dataInfo?.objectionAndLearning,
        taskId: props.dataInfo?.taskId
      }
    : {}
})

const handlePreview = (url) => {
  emit('preview', url)
}
</script>

<style lang="less" scoped>
.analysis-card {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  .card-title {
    padding: 8px;
    background-color: #f7f8fa;
    border-radius: 4px;
    cursor: pointer;
  }
  .text {
    margin-left: 8px;
    color: #323233;
    font-weight: 600;
  }
}
.is-mobile {
  font-size: 14px;
}
</style>
